<template>
  <v-overlay :model-value="overlay" class="align-center justify-center">
    <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>
  </v-overlay>
  <v-container v-if="!overlay" class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="600">
        <div class="text-h5 text-center mb-8 font-weight-medium">Registration Complete</div>
        <OrderDetailComponent
          v-if="overlay == false && getMyRegistration?.order"
          :order="getMyRegistration.order"></OrderDetailComponent>
        <v-divider></v-divider>
        <router-link :to="{ name: 'Home' }">
          <v-btn block color="primary" class="rounded-lg mb-8" elevation="2" type="submit"
            >Continue</v-btn
          >
        </router-link>
      </v-sheet>
    </v-row></v-container
  >
</template>
<script lang="ts" setup>
import OrderDetailComponent from '@/components/orders/OrderDetailComponent.vue';
import { useOrderStore, useRegistrationStore } from '@/stores';
import { useUpdateStatusStore } from '@/stores/modules';
import { SNACKSTATUS } from '@/stores/util';
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
const emit = defineEmits(['snack']);
const route = useRoute();
const orderStore = useOrderStore();
const statusStore = useUpdateStatusStore();
const overlay = ref<boolean>(true);

const orderId = ref(
  Array.isArray(route.params.orderId) ? route.params.orderId[0] : (route.params.orderId ?? ''),
);

const registrationStore = useRegistrationStore();
const getMyRegistration = registrationStore.getMyRegistration.data;

const paymentIntent = Array.isArray(route.query.payment_intent)
  ? route.query.payment_intent[0]
  : (route.query.payment_intent ?? '');

onMounted(async () => {
  if (!getMyRegistration?.order) {
    //todo: show error
  } else if (getMyRegistration.registered_date) {
    overlay.value = false;
  } else if (paymentIntent && orderId) {
    orderStore.finalizeOrder.mutateAsync({ orderId: orderId.value, paymentIntent: paymentIntent });
  }
});

watch(
  () => statusStore.getStatus('finalizeOrder'),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    if (value === 'success:update') {
      overlay.value = false;
      emit('snack', 'Order', value, null);
    }
  },
);
</script>
